export default __webpack_public_path__ + "static/media/mission-container.a9e81b38.webp";